/**
 * В браузере схемы разбираются интерпретируемым путём, а не скомпилированным.
 *
 * `zod` при создании схемы решает, собирать ли быстрый разбор через
 * `Function`, и, чтобы это выяснить, делает пробу — `new Function("")`.
 * Под политикой §10.4 (`script-src 'self' blob:`) проба обречена: браузер
 * отказывает, отказ проглатывается `try`, разбор идёт медленным путём
 * и работает. Но нарушение CSP браузер успевает напечатать в консоль
 * и разослать событием — а в консоли продакшена оно неотличимо
 * от настоящего.
 *
 * Послабление `unsafe-eval` ради скорости разбора форм — обмен, которого
 * делать не стоит. `jitless` закрывает вопрос с другой стороны: пробы нет,
 * а путь разбора под CSP тот же, каким он был и так.
 *
 * Настройка только для браузера. `api` и `access-gateway` живут в Node,
 * CSP там нет, а телеметрию площадок они разбирают постоянно — им
 * компиляция нужна.
 *
 * Модуль подключается первым импортом `index.ts` и обязан там остаться:
 * решение о компиляции `zod` принимает в конструкторе `$ZodObject`,
 * то есть при создании первой же схемы, а схемы пакета создаются
 * на загрузке модулей. Настройка, сделанная позже, опоздает. Полагаться
 * на порядок импортов в приложении тут нельзя: сборщик режет код
 * на чанки, и чанк со схемами выполняется раньше тела точки входа.
 */
import { z } from 'zod';
/*
  Браузер опознаётся через `in`, а не через `typeof document`: пакет собирается
  без библиотеки `dom` — и правильно, схемы к странице отношения не имеют, —
  поэтому `document` здесь не объявлен как имя.
*/
if ('document' in globalThis) {
    z.config({ jitless: true });
}
//# sourceMappingURL=jit.js.map